import { Suspense } from 'react';
import { useTheme } from '@mui/material/styles';
import { Layout } from 'modules/minimal-ui-theme';
import { LazyLogoutModal } from 'modules/modals';
import { Profile, ProfileHeader } from 'modules/profile';

export const AccountPage = () => {
  const theme = useTheme();

  return (
    <Layout
      childrenStyles={{
        p: '0 0 47px 0',
        [theme.breakpoints.up('sm')]: {
          px: 0,
          maxWidth: '100%'
        }
      }}
      header={<ProfileHeader />}
      withFooter
    >
      <Profile />
      <Suspense>
        <LazyLogoutModal />
      </Suspense>
    </Layout>
  );
};
